import React, { useState, useContext } from "react"
import { AlertsContext } from "../../../utils/providers/alerts"
import { db, auth } from "../../../utils/firebase"
import firebase from "firebase"

/**
 * UI components
 */
import Input from "../../ui/inputs/input"
import Button from "../../ui/button/button"
import Window from "../../structure/window/window"
import WindowCard from "../../ui/window-card/window-card"
import Datepicker from "../../ui/datepicker/datepicker"

/**
 * Modal form for recording a manual payment (bank transfer, cheque, any
 * payment taken outside of Stripe). Triggered from the Payments tab.
 */
export default function AddPayment({ bookingID, close, onSaved }) {
	const [saving, setSaving] = useState(false)
	const [amount, setAmount] = useState("")
	const [reference, setReference] = useState("")
	const [payee, setPayee] = useState("")
	const [paidMillis, setPaidMillis] = useState("")

	const { pushAlert } = useContext(AlertsContext)

	const savePayment = async () => {
		setSaving(true)

		const amountVal = Number.parseFloat(amount)

		await db.collection(`bookings/${bookingID}/payments`).add({
			amount: amountVal,
			payee,
			reference,
			source: "MANUAL",
			paid_date: firebase.firestore.Timestamp.fromMillis(paidMillis),
			created: firebase.firestore.FieldValue.serverTimestamp(),
			saved_by: auth.currentUser.uid,
		})

		setSaving(false)

		pushAlert({
			type: "SUCCESS",
			title: "Payment recorded",
		})

		if (typeof onSaved === "function") onSaved()
		if (typeof close === "function") close()
	}

	return (
		<Window
			title="Record a manual payment"
			className="slim"
			close={() => close && close()}>
			<WindowCard>
				<div className="input-grid cols-2">
					<div className="span-2">
						<Input
							type="text"
							placeholder="Payee:"
							value={payee}
							onChange={setPayee}
						/>
					</div>

					<Input
						type="number"
						placeholder="Amount:"
						symbol="£"
						value={amount}
						onChange={setAmount}
					/>

					<Input
						type="text"
						placeholder="Reference:"
						value={reference}
						onChange={setReference}
					/>

					<div className="span-2">
						<Datepicker
							placeholder="Payment date:"
							onSelect={(date) => setPaidMillis(date)}
						/>
					</div>

					<div className="span-2">
						<Button
							label="Save payment"
							fullWidth={true}
							loading={saving}
							loadingText="Saving..."
							onClick={() => savePayment()}
							disabled={!amount || !payee || !reference || !paidMillis}
						/>
					</div>
				</div>
			</WindowCard>
		</Window>
	)
}
